import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {cloneDeep} from "lodash";
import {OrgMin} from "../Models/OrgMin";
import {TableBoName} from "../enums/table-bo-name.enum";

@Component({
	selector: 'app-agences',
	templateUrl: './agences.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./agences.component.less']
})
export class AgencesComponent implements OnInit {
	userId: any = localStorage.getItem('user_id');
	agencies: OrgMin[] = [];
	originalAgencies: OrgMin[] = [];
	globalTxt: any;
	modalsTxt: any;
	textes: any;
	searchTerm: string = '';
	tabOptions: any = this.app.sharedToolsService.initTabOptions(TableBoName.AGENCIES);

	constructor(
		public app: AppComponent,
	) {
	}

	ngOnInit(): void {
		// Get if the session exists or not and redirect to the login page if not
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		// Remove the modalOpen from localStorage to avoid problems
		localStorage.removeItem("modalOpen");

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get the settings
		this.app.sharedToolsService.getSettings();

		// Get all organizations by user ID (the agencies)
		this.getAllOrganisationsByUsrId(this.userId);

		this.app.sharedToolsService.loadTexts(_nameJson)
			.subscribe(textes => {
				this.textes = textes;

				// Get the global texts
				this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
					this.globalTxt = globalTxt;

					// Get the modals texts
					this.app.dataInitService.getModalTextsOnce(modalsTxt => {
						this.modalsTxt = modalsTxt;
					});

					// Set the previous and next labels for pagination
					this.app.previousLabelTxt = this.app.sharedToolsService.getPaginationLabels('prev');
					this.app.nextLabelTxt = this.app.sharedToolsService.getPaginationLabels('next');
				})
			})
	}

	getAllOrganisationsByUsrId(_usrId: number) {
		this.app.apiToolsService.getAllOrganisationsByUsrId(_usrId).subscribe((agencies: any) => {
			console.log("getAllOrganisationsByUsrId ==> ", agencies);
			let organisations: OrgMin[] = [];
			organisations = cloneDeep(agencies);

			// Add the full address to each agency
			organisations.forEach((org: OrgMin) => {
				if (org.ADR_ID) {
					let address = org.ADR_ADRESSE_1 || '';
					let postal_code = org.ADR_CP || '';
					let city = org.ADR_VILLE || '';
					let country = org.PYS_CODE || '';
					org.ORG_ADRESSE_FULL = address + " " + postal_code + " " + city + " " + country;
				}
			});

			this.agencies = organisations;
			this.originalAgencies = organisations;

			// Sort the table by descending ID by default
			this.app.sharedToolsService.sortTable(this.tabOptions.sortKey, this.agencies, this.tabOptions);
		})
	}

	search() {
		if (this.searchTerm) {
			this.agencies = this.app.sharedToolsService.searchInTable(
				this.searchTerm,
				this.originalAgencies,
				[],
				this.textes.blocTable.cols);
		} else {
			this.agencies = [...this.originalAgencies];
		}
		this.tabOptions = this.app.sharedToolsService.initTabOptions(TableBoName.AGENCIES);
	}

	deleteAgency(_id: number) {
		console.log("deleteAgency ==> ", _id);

		this.app.confirmDialogService.confirmThis(
			"", //title
			this.modalsTxt.modalSupp, //text
			"confirm", //type
			"suppression", //template
			() => {
				// Call the API to delete the agency
				this.delOrganisation(_id);
			},
			() => {
			});
	}

	delOrganisation(_orgId: number) {
		this.app.apiToolsService.delOrganisation(_orgId).subscribe(
			(res: any) => {
				console.log("deleteAgency ==> ", res);
				this.app.confirmDialogService.confirmThis(
					"", //title
					this.modalsTxt.modalSuccessDeleteOrg, "alert", "",
					() => {
						location.reload();
					},
					() => {
					});
			}, error => {
				console.log("error ==> ", error);
				this.app.confirmDialogService.confirmThis('', error.error.Message, 'alert', '', () => {
				}, () => {
				});
			});
	}

}
